import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { institutionApis } from "@services/apis/Institution";
import { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface AddCrossRampIndiaFeesSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (success: boolean) => void;
}

const AddCrossRampIndiaFeesSlider: React.FC<
  AddCrossRampIndiaFeesSliderProps
> = ({ isOpen, onClose, onConfirm }) => {
  const [payinFees, setPayinFees] = useState<number | undefined>(undefined);
  const [payoutFees, setPayoutFees] = useState<number | undefined>(undefined);
  const [p2pCryptoCurrencyId, setP2PCryptoCurrencyId] = useState<
    number | undefined
  >(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const { handleSuccess, handleError } = useSnackbarMessage();

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await institutionApis.addP2PFees({
        payInFees: payinFees || 0,
        payOutFees: payoutFees || 0,
        p2pCryptoCurrencyId: p2pCryptoCurrencyId || 0,
      });
      handleSuccess({ message: "Fees added successfully" });
      onConfirm(true);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Updating status failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlidingPanel
      showConfirm={false}
      isOpen={isOpen}
      isSlider={false}
      isMobile={false}
      heading={"Add CPG Commission"}
      onClose={() => {
        onClose();
      }}
    >
      <div className="flex flex-col p-[16px] gap-[16px] overflow-y-auto">
        <GlobalTextInputField
          type="number"
          title="P2P Crypto Currency ID"
          placeholder="Enter crypto currency ID here"
          value={p2pCryptoCurrencyId?.toString() || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setP2PCryptoCurrencyId(Number(e.target.value))
          }
        />
        <GlobalTextInputField
          type="number"
          title="Payin Fee"
          placeholder="Enter payin fee here"
          value={payinFees?.toString() || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPayinFees(Number(e.target.value))
          }
        />
        <GlobalTextInputField
          type="number"
          title="Pay Out Fee"
          placeholder="Enter payout fee here"
          value={payoutFees?.toString() || ""}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setPayoutFees(Number(e.target.value))
          }
        />
        <CustomButton
          isActive={true}
          isButtonLoading={loading}
          onClick={handleSubmit}
          text="SUBMIT"
        />
      </div>
    </SlidingPanel>
  );
};

export default AddCrossRampIndiaFeesSlider;
